// Phase 15 Plan 05 Task 3 — Net wrapper for GET /api/leaderboard/{ladderKey}.
//
// Default (no flags) returns the KV-cached top-100 slice (slice_kind=top100).
// Plan 04's `?near=true` branch returns a ~21-row slice around the caller's
// rank plus a `rank_region` summary (top_5/top_25/median ranks + ladder_size).
//
// The handler reads the caller's user_uuid from the bearer ONLY — any
// `?user_uuid=` query value is ignored (T-15-03 / T-15-17 / DEC-021).

import type { components } from '@runegambit/api-types'
import { apiFetch } from './client'

export type LeaderboardResponse = components['schemas']['LeaderboardResponse']
export type LadderKey = components['schemas']['LadderKey']

export interface FetchLeaderboardOptions {
  /**
   * When true, request the near-rank slice instead of the top-100. The
   * caller is bearer-derived; the URL just toggles the flag.
   */
  near?: boolean
}

/**
 * GET /api/leaderboard/{ladderKey}[?near=true]
 *
 * Returns LeaderboardResponse — always includes `slice_kind` discriminator
 * + `entries`. When the caller is below the top-100 AND `near=true`,
 * `rank_region` is populated.
 */
export async function fetchLeaderboard(
  ladderKey: LadderKey,
  opts: FetchLeaderboardOptions = {},
): Promise<LeaderboardResponse> {
  const q = opts.near === true ? '?near=true' : ''
  return apiFetch<LeaderboardResponse>(
    `/api/leaderboard/${ladderKey}${q}`,
    'GET',
  )
}
